import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorderRounded";
import FavoriteIcon from "@mui/icons-material/FavoriteRounded";
import { IconButton, Tooltip } from "@mui/material";
import { useTemplate } from "containers/templateDetail/store";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { postFevorites } from "services/template";
import { RootState } from "stores/store";

export default function Favorite(): React.ReactElement {
  const { id: templateID } = useTemplate();
  const favorites = useSelector((store: RootState) => store.app.favorites);
  const isFavorite = React.useMemo(() => {
    return favorites?.findIndex((item) => item === templateID) === -1
      ? false
      : true;
  }, [favorites]);
  const dispatch = useDispatch();

  const [showFavorite, setFavorite] = React.useState(isFavorite);

  const handleClick = () => {
    setFavorite((s) => !s);

    postFevorites({
      template_id: templateID,
    }).then((res) => {
      dispatch({
        type: "APP_INIT",
        data: {
          favorites: res.data.favorites,
        },
      });
    });
  };

  return (
    <Tooltip
      title={showFavorite ? "Remove From Favorites" : "Add To Favorites"}
      arrow={true}
      placement="top"
      sx={{
        zIndex: 4,
        cursor: "pointer",
      }}
    >
      <IconButton sx={{ ml: 1 }} onClick={handleClick}>
        {showFavorite ? (
          <FavoriteIcon color="primary" fontSize="large" />
        ) : (
          <FavoriteBorderIcon color="primary" fontSize="large" />
        )}
      </IconButton>
    </Tooltip>
  );
}
